export enum BottomDrawerComponentType {
  UpdateConversations = 'UpdateConversations',
  AnalyseActions = 'AnalyseActions',
  AnalysesListActions = 'AnalysesListActions'
}
